import React from 'react';
import { Link } from 'react-router-dom';
import LogoBlue from '../../assets/logo blue.svg';
import WechatQr from '../../assets/qr.png';
import BgConstr from '../../assets/bg_constr.JPG';

const Azerbaijan = () => {
  return (
    <div className="azerbaijan-coming-soon">
      <div className="azerbaijan-coming-soon__left">
        <Link to="/" className="azerbaijan-coming-soon__logo">
          <img src={LogoBlue} alt="Pure Travel Azerbaijan" />
        </Link>

        <div className="azerbaijan-coming-soon__content">
          
          <h1 className="azerbaijan-coming-soon__title">即将上线</h1>

          <p className="azerbaijan-coming-soon__body">
            在此期间，欢迎通过邮件与我们联系：
          </p>
          <p className="azerbaijan-coming-soon__email">✉️ gfarid@puretrip.org</p>
        </div>

        <div className="azerbaijan-coming-soon__footer">
          <div className="azerbaijan-coming-soon__wechat">
            <span className="azerbaijan-coming-soon__wechat-label">
             现在关注我们，获取最新更新！
            </span>
            <img
              className="azerbaijan-coming-soon__wechat-img"
              src={WechatQr}
              alt="WeChat QR code"
            />
          </div>
        </div>
      </div>

      <div className="azerbaijan-coming-soon__right">
        <div className="azerbaijan-coming-soon__image-overlay" />
      </div>

      {/* Page-specific styles */}
      <style>{`
        .azerbaijan-coming-soon {
          min-height: 100vh;
          display: flex;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif;
          background-color: #ffffff;
        }

        .azerbaijan-coming-soon__left,
        .azerbaijan-coming-soon__right {
          flex: 1;
        }

        .azerbaijan-coming-soon__left {
          display: flex;
          flex-direction: column;
          padding: 40px 60px;
          box-sizing: border-box;
        }

        .azerbaijan-coming-soon__logo {
          margin-bottom: 20px;
        }

        .azerbaijan-coming-soon__logo img {
          height: 60px;
          width: auto;
          display: block;
        }

        .azerbaijan-coming-soon__content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          max-width: 420px;
        }

        .azerbaijan-coming-soon__eyebrow {
          margin: 0 0 4px;
          font-size: 14px;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: #999999;
        }

        .azerbaijan-coming-soon__title {
          margin: 0 0 20px;
          font-size: 54px;
          font-weight: 600;
          letter-spacing: 0.04em;
          color:#1F5DA2;
        }

        .azerbaijan-coming-soon__body {
          margin: 0 0 8px;
          font-size: 14px;
          color: #555555;
        }

        .azerbaijan-coming-soon__email {
          margin: 0 0 16px;
          font-size: 16px;
          font-weight: 500;
          color: #1F5DA2;
        }

        .azerbaijan-coming-soon__footer {
          margin-top: 24px;
        }

        .azerbaijan-coming-soon__wechat {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          padding: 10px 14px;
          border-radius: 8px;
          background-color: #f7f9fc;
        }

        .azerbaijan-coming-soon__wechat-label {
          font-size: 14px;
          color: #333333;
        }

        .azerbaijan-coming-soon__wechat-img {
          width: 96px;
          height: 96px;
          border-radius: 8px;
          background-color: #ffffff;
          border: 1px solid #e0e6f0;
          object-fit: cover;
        }

        .azerbaijan-coming-soon__right {
          background-image: url(${BgConstr});
          background-size: cover;
          background-position: center;
          position: relative;
          min-height: 100vh;
        }

        .azerbaijan-coming-soon__image-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to bottom,
            rgba(31, 93, 162, 0.05),
            rgba(31, 93, 162, 0.35)
          );
          mix-blend-mode: multiply;
        }

        @media (max-width: 900px) {
          .azerbaijan-coming-soon {
            flex-direction: column;
          }

          .azerbaijan-coming-soon__left {
            padding: 24px 20px 32px;
          }

          .azerbaijan-coming-soon__content {
            max-width: none;
          }

          .azerbaijan-coming-soon__right {
            min-height: 100vh;
          }
        }
      `}</style>
    </div>
  );
};

export default Azerbaijan;
